module.exports = __webpack_public_path__ + "static/media/yellow-triangle.935a3083.svg";